<template>
  <aside class="user-side">
    <div class="user-info">
      <div class="avatar">{{ avatarInitial }}</div>
      <div class="name">{{ displayName }}</div>
      <div class="tip">{{ last4Mobile }}</div>
    </div>

    <div class="nav-list">
      <div :class="['nav-item', { active: active === 'profile' }]" @click="goTo('/profile')">
        <i class="el-icon-user"></i> 个人中心
      </div>
      <div :class="['nav-item', { active: active === 'change-password' }]" @click="goTo('/change-password')">
        <i class="el-icon-key"></i> 修改密码
      </div>
      <div :class="['nav-item', { active: active === 'favorites' }]" @click="goTo('/favorites')">
        <i class="el-icon-star-on"></i> 我的收藏
      </div>
      <div :class="['nav-item', { active: active === 'orders' }]" @click="goTo('/orders')">
        <i class="el-icon-tickets"></i> 我的订单
      </div>
      <div :class="['nav-item', { active: active === 'trial' }]" @click="goTo('/trial')">
        <i class="el-icon-s-promotion"></i> 试用申请
      </div>
      <div class="nav-divider"></div>
      <div class="nav-item danger" @click="handleLogout">
        <i class="el-icon-switch-button"></i> 退出登录
      </div>
    </div>
  </aside>
</template>

<script>
import { getLast4Mobile, logout } from '@/utils/auth'

export default {
  name: 'UserCenterSidebar',
  props: {
    active: {
      type: String,
      required: true
    },
    userInfo: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    displayName () {
      const user = this.userInfo || {}
      return user.realName || user.nickname || user.username || user.mobile || '--'
    },
    avatarInitial () {
      return this.displayName.slice(0, 1).toUpperCase()
    },
    last4Mobile () {
      return getLast4Mobile((this.userInfo || {}).mobile)
    }
  },
  methods: {
    goTo (path) {
      if (this.$route.path !== path) this.$router.push(path)
    },
    handleLogout () {
      this.$confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        logout()
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.user-side {
  width: 240px;
  min-height: 100%;
  align-self: stretch;
  box-sizing: border-box;
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  flex-shrink: 0;

  .user-info {
    text-align: center;
    padding-bottom: 20px;
    border-bottom: 1px solid #f0f0f0;
    margin-bottom: 16px;

    .avatar {
      width: 64px;
      height: 64px;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      color: #fff;
      font-weight: bold;
      margin: 0 auto 12px;
    }

    .name {
      font-size: 16px;
      color: #333;
      font-weight: 500;
      margin-bottom: 4px;
      word-break: break-all;
    }

    .tip {
      font-size: 13px;
      color: #999;
    }
  }

  .nav-list {
    .nav-item {
      display: flex;
      align-items: center;
      padding: 12px 16px;
      border-radius: 8px;
      cursor: pointer;
      transition: all 0.3s;
      font-size: 14px;
      color: #666;

      i {
        margin-right: 10px;
        font-size: 18px;
      }

      &:hover {
        background: #f5f7fa;
        color: #333;
      }

      &.active {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        color: #fff;
      }

      &.danger {
        color: #f56c6c;

        &:hover {
          background: #fef0f0;
          color: #f56c6c;
        }
      }
    }

    .nav-divider {
      height: 1px;
      background: #f0f0f0;
      margin: 8px 16px;
    }
  }
}

@media screen and (max-width: 768px) {
  .user-side {
    width: 100%;
    min-height: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/UserCenterSidebar.vue